export const SITE_URL = "https://deerparkestates.ca";

// Per-route SEO metadata. Keys are exact pathnames; dynamic routes use a matcher.
export const DEFAULT_SEO = {
  title: "New Homes for Sale near Edmonton — Deer Park Estates, Spruce Grove, AB",
  description:
    "Deer Park Estates — new homes and estate lots in a master-planned community in Spruce Grove, Alberta, 20 minutes west of Edmonton. Builders, stages, parks and an interactive master plan.",
};

export const ROUTE_SEO = {
  "/": {
    title: "New Homes for Sale near Edmonton — Deer Park Estates, Spruce Grove, AB",
    description:
      "Buy a new home 20 minutes west of Edmonton. Deer Park Estates in Spruce Grove, Alberta offers estate lots, 11 custom home builders, ponds, parks and trails. Stage 8 now selling.",
  },
  "/new-homes-edmonton": {
    title: "New Homes for Sale near Edmonton | Spruce Grove — Deer Park Estates",
    description:
      "Looking to buy a new house in Edmonton? Deer Park Estates in Spruce Grove is 20–25 min west on Hwy 16 — estate lots, 11 custom builders, new home warranty. See lots and builders.",
  },
  "/lots-for-sale-spruce-grove": {
    title: "Lots for Sale in Spruce Grove, AB — Estate Lots near Edmonton | Deer Park Estates",
    description:
      "Front-drive, walkout, pie and corner lots in Deer Park Estates, Spruce Grove. Exact dimensions and plot plans for every lot; Stage 8 now selling. Build with an approved custom home builder.",
  },
  "/build-your-home-alberta": {
    title: "Build Your Custom Home in Alberta — Spruce Grove near Edmonton | Deer Park Estates",
    description:
      "How a custom home build works at Deer Park Estates: choose a lot, choose from 11 approved builders, design, build (7–10 months) and move in with Alberta's 1-2-5-10 new home warranty.",
  },
  "/master-plan": {
    title: "Interactive Master Plan — Lots & Stages in Spruce Grove near Edmonton | Deer Park Estates",
    description:
      "Tap any lot on the Deer Park Estates master plan to see size, frontage, availability and the builder. A master-planned new home community in Spruce Grove, 20 min from Edmonton.",
  },
  "/available-land": {
    title: "Available Lots for New Homes — Spruce Grove near Edmonton | Deer Park Estates",
    description:
      "Browse available lots at Deer Park Estates in Spruce Grove, Alberta — dimensions, frontage, depth and plot plans. Pick a lot, choose a custom home builder and build your new home near Edmonton.",
  },
  "/sold-reserved": {
    title: "Committed Lots · Homes Coming in Spruce Grove | Deer Park Estates",
    description:
      "See which lots are committed to custom home builders across the stages of Deer Park Estates, Spruce Grove, Alberta — and connect with the builder to make one your home.",
  },
  "/stages": {
    title: "New Home Lots by Stage — Spruce Grove, 20 min from West Edmonton | Deer Park Estates",
    description:
      "Twelve stages of Deer Park Estates in Spruce Grove, Alberta: Stages 1–6 built out, Stage 8 now selling, Stages 7 and 9 committed to builders. See lots, builders and plot plans by stage.",
  },
  "/builders": {
    title: "Custom Home Builders in Spruce Grove & Edmonton Area | Deer Park Estates",
    description:
      "Meet the 11 approved custom home builders of Deer Park Estates in Spruce Grove, Alberta — galleries, show homes, quick possessions and the lots each builder is building on near Edmonton.",
  },
  "/videos": {
    title: "Videos — Aerial Tours of Deer Park Estates, Spruce Grove",
    description:
      "Watch aerial tours of the ponds, parks, lots and new homes at Deer Park Estates in Spruce Grove, Alberta — 20 minutes west of Edmonton.",
  },
  "/commercial": {
    title: "Commercial Centre — Spruce Grove Retail at Deer Park Estates",
    description:
      "A grocery-anchored neighbourhood retail centre at the gateway to Deer Park Estates, Spruce Grove, Alberta — everyday shopping, dining and services for the community.",
  },
  "/apartment": {
    title: "Apartment Project — Low-Maintenance Living in Spruce Grove | Deer Park Estates",
    description:
      "A planned multi-family apartment residence at Deer Park Estates, Spruce Grove, Alberta — steps from the commercial centre, 20 minutes from Edmonton.",
  },
  "/location": {
    title: "Location — Spruce Grove, 20 Minutes West of Edmonton | Deer Park Estates",
    description:
      "Deer Park Estates sits in northwest Spruce Grove, Alberta, on Highway 16 — 20–25 min to West Edmonton, 35 min to downtown. Nearby schools, Tri-Leisure Centre, shopping, parks and transit.",
  },
  "/community": {
    title: "Community Life in Spruce Grove — Parks, Trails, Shops | Deer Park Estates",
    description:
      "Discover life at Deer Park Estates — local businesses, parks and amenities, and getting around Spruce Grove and Edmonton.",
  },
  "/community/local-businesses": {
    title: "Local Businesses near Deer Park Estates, Spruce Grove",
    description:
      "A directory of local businesses serving the Deer Park Estates community in Spruce Grove, Alberta.",
  },
  "/community/parks-and-amenities": {
    title: "Parks, Ponds & Trails — Deer Park Estates, Spruce Grove",
    description:
      "Explore the parks, trails, stormwater ponds and green amenities designed for the Deer Park Estates community in Spruce Grove, Alberta.",
  },
  "/community/getting-around": {
    title: "Getting Around — Spruce Grove to Edmonton Transit & Roads | Deer Park Estates",
    description:
      "Highway 16, Route 560 transit to Edmonton and local roads around Deer Park Estates in Spruce Grove, Alberta.",
  },
  "/about": {
    title: "About Deer Park Estates & Broadview Developments — Spruce Grove, Alberta",
    description:
      "The story and vision behind Deer Park Estates, a master-planned new home community in Spruce Grove, Alberta, developed by Broadview Developments Inc.",
  },
  "/history": {
    title: "About Deer Park Estates & Broadview Developments — Spruce Grove, Alberta",
    description:
      "The story and vision behind Deer Park Estates, a master-planned new home community in Spruce Grove, Alberta, developed by Broadview Developments Inc.",
  },
  "/contact": {
    title: "Contact — New Homes & Lots in Spruce Grove near Edmonton | Deer Park Estates",
    description:
      "Ask about new homes, lots and builder opportunities at Deer Park Estates in Spruce Grove, Alberta, 20 minutes west of Edmonton.",
  },
};

// Dynamic-route fallbacks (pathname startsWith)
export const DYNAMIC_SEO = [
  {
    prefix: "/stages/",
    title: "Stage Detail · Deer Park Estates",
    description:
      "Detailed view of a development stage at Deer Park Estates, Spruce Grove, Alberta — lots, dimensions and availability.",
  },
  {
    prefix: "/builders/",
    title: "Builder Profile · Deer Park Estates",
    description:
      "Profile and portfolio of a custom home builder at Deer Park Estates, Spruce Grove, Alberta.",
  },
];

// Routes that should not be indexed
export const NOINDEX_PREFIXES = ["/login", "/admin", "/portal"];

export function resolveSeo(pathname) {
  const p = pathname !== "/" ? pathname.replace(/\/+$/, "") : "/";
  if (ROUTE_SEO[p]) return { ...ROUTE_SEO[p], noindex: isNoindex(p) };
  const dyn = DYNAMIC_SEO.find((d) => p.startsWith(d.prefix));
  if (dyn) return { title: dyn.title, description: dyn.description, noindex: isNoindex(p) };
  return { ...DEFAULT_SEO, noindex: isNoindex(p) };
}

export function isNoindex(pathname) {
  return NOINDEX_PREFIXES.some((p) => pathname.startsWith(p));
}

// Human-readable labels for breadcrumb segments
export const SEGMENT_LABELS = {
  "master-plan": "Master Plan",
  "available-land": "Available Land",
  "sold-reserved": "Committed Lots",
  "new-homes-edmonton": "New Homes near Edmonton",
  "lots-for-sale-spruce-grove": "Lots for Sale in Spruce Grove",
  "build-your-home-alberta": "Build Your Home in Alberta",
  stages: "Stages",
  builders: "Builders",
  commercial: "Commercial",
  apartment: "Apartment",
  location: "Location",
  community: "Community",
  "local-businesses": "Local Businesses",
  "parks-and-amenities": "Parks & Amenities",
  "getting-around": "Getting Around",
  about: "About",
  contact: "Contact",
};

const titleCase = (s) =>
  s.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// Returns [{ name, path }] starting from Home; empty extra crumbs on root
export function buildBreadcrumbs(pathname) {
  const p = pathname !== "/" ? pathname.replace(/\/+$/, "") : "/";
  const crumbs = [{ name: "Home", path: "/" }];
  if (p === "/") return crumbs;
  const segs = p.split("/").filter(Boolean);
  let acc = "";
  segs.forEach((seg) => {
    acc += `/${seg}`;
    crumbs.push({ name: SEGMENT_LABELS[seg] || titleCase(seg), path: acc });
  });
  return crumbs;
}

// Real-estate agent / seller organization (Broadview Developments Inc.)
export const ORG_CONTACT = {
  legalName: "Broadview Developments Inc.",
  telephone: "+1-780-445-8188",
  faxNumber: "+1-780-483-1424",
  email: "franz.leung@gmail.com",
  streetAddress: "13912 - 85 Ave.",
  addressLocality: "Edmonton",
  addressRegion: "AB",
  postalCode: "T5R 3Y8",
  addressCountry: "CA",
};

// FAQ content (shown on /contact + emitted as FAQPage structured data)
export const FAQ_ITEMS = [
  {
    q: "Who can purchase land at Deer Park Estates?",
    a: "Lots at Deer Park Estates are available to registered, approved home builders only — they are not for sale to private individuals. Builders can request access through our land team or the Builders Login.",
  },
  {
    q: "Where is Deer Park Estates located?",
    a: "Deer Park Estates is a master-planned community in northwest Spruce Grove, Alberta — roughly 220 acres of tree-lined streets, two ponds, preserved natural areas, parks and trails, with easy access to the Yellowhead Highway.",
  },
  {
    q: "Which stages are currently available?",
    a: "The community is delivered across 12 stages. Stages 1–6 are built out, lots in Stages 7 and 9 are committed by builders, Stage 8 is now selling, and later stages are in development. See the Stages page for current availability.",
  },
  {
    q: "Are lot prices shown on the website?",
    a: "No. Exact parcel pricing is shared privately with registered builders on enquiry. Public pages show lot dimensions, frontage, depth and plot plans, but not prices.",
  },
  {
    q: "What details are provided for each lot?",
    a: "Each lot listing includes area, frontage and depth, and — where available — a downloadable plot plan PDF. Servicing and zoning details are provided to builders on request.",
  },
  {
    q: "How do I become an approved builder or get access?",
    a: "Contact our land team through the enquiry form on this page, or sign in via the Builders Login to access confidential documents and the investor portal.",
  },
  {
    q: "What amenities does the community offer?",
    a: "Deer Park Estates features stormwater ponds, walking trails, parks and playgrounds, a local shopping plaza with everyday businesses, and public transit including Spruce Grove Route 560 to Edmonton.",
  },
];

export function faqPageLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

